import React from 'react';
import {Link} from 'react-router';
export default class RowItemListDocumentSearchPopup extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten}</td>
        <td>{this.props.item.soTrang}</td>
        <td>{this.props.item.loaiTaiLieuTLBC.ten}</td>
        <td>{this.props.item.tinhTrangTaiLieu}</td>
        <td className="none-boder underline-name">
          <Link>{this.props.item.fileattach}</Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/add/RowItemListDocumentSearchPopup.jsx